const mutations = {
  setVendorList(state, data) {
    state.vendorList = data;
  },
  setVendor(state, data) {
    state.vendor = data;
  },
  resetVendor(state) {
    state.vendor = {
      firstName: "",
      lastName: "",
      age: "",
      gender: "male",
      email: "",
      phone: "",
      address: "",
      password: "",
      isDisable: false,
      commisionPercentage: 0,
      isActive: true,
      serviceCategoryId: ""
    };
  },
  setVendorInvoiceData(state, data) {
    state.vendorInvoiceData = data;
  }
};
export default mutations;
